import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsFeatureEnabled } from 'src/commons/hooks/index';
import { WeblabedFeatures } from 'src/commons/constants';
import { selectSelectedLink } from 'src/features/nav/store/slice';
import { fetchSelectedApplication } from 'src/features/nav/store/slice.actions';
import { NavMetricPublisher } from 'src/commons/utils/metrics';

export default (): void => {
  const dispatch = useDispatch();
  const isPnCsrFeatureEnabled = useIsFeatureEnabled(WeblabedFeatures.PN_CSR);
  const currentApplication = useSelector(selectSelectedLink);
  const isSelectedApplicationFetchRequired =
    currentApplication?.isCSREnabled && isPnCsrFeatureEnabled;

  let currentUrl = window.location.pathname;
  const intervalCallback = (): void => {
    if (!!currentUrl && window.location.pathname !== currentUrl) {
      currentUrl = window.location.pathname;
      dispatch(fetchSelectedApplication());
      NavMetricPublisher.publishCounterMonitor(`ClientSideRoutingEvent`, 1);
    }
  };

  useEffect(() => {
    if (isSelectedApplicationFetchRequired) {
      const interval = setInterval(intervalCallback, 50);
      return () => clearInterval(interval);
    }
  }, [isSelectedApplicationFetchRequired]);
};
